class PDPModal extends HTMLElement {
  constructor() {
    super();
    this.boundHandleKeyDown = this.handleKeyDown.bind(this);
    this.boundHandleKeyUp = this.handleKeyUp.bind(this);
    this.boundShowModal = this.showModal.bind(this);
    this.boundHideModal = this.hideModal.bind(this);
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.openButton = this.querySelector('#pdp-modal-button');
    this.modal = this.querySelector('#pdp-modal');
    this.dialog = this.modal.querySelector("[role='dialog']");

    if (!this.openButton || !this.modal || !this.dialog) return;

    this.focusableElements = this.dialog.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );

    this.openButton.addEventListener('click', this.boundShowModal);
    this.modal.addEventListener('click', this.boundHandleOutsideClick);
    this.dialog.addEventListener('keydown', this.boundHandleKeyDown);
    this.dialog.addEventListener('keyup', this.boundHandleKeyUp);
  }

  disconnectedCallback() {
    this.openButton?.removeEventListener('click', this.boundShowModal);
    this.modal?.removeEventListener('click', this.boundHandleOutsideClick);
    this.dialog?.removeEventListener('keydown', this.boundHandleKeyDown);
    this.dialog?.removeEventListener('keyup', this.boundHandleKeyUp);
    this.closeButton?.removeEventListener('click', this.boundHideModal);
  }

  showModal() {
    this.modal.style.display = 'grid';
    this.dialog.focus();

    // Set focusables again (after injected content)
    this.focusableElements = this.dialog.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );

    // Find the close button *now*, after content is rendered
    this.closeButton = this.dialog.querySelector('.button--close');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.boundHideModal);
    }
  }

  hideModal() {
    this.modal.style.display = 'none';
    this.openButton.focus();

    // Clean up in case button was added
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.boundHideModal);
    }
  }

  handleOutsideClick(e) {
    if (e.target === this.modal) {
      this.hideModal();
    }
  }

  handleKeyDown(e) {
    if (e.key === 'Tab') {
      const focusables = this.focusableElements;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  handleKeyUp(e) {
    if (e.key === 'Escape') {
      this.hideModal();
    }
  }
}

customElements.define('pdp-modal', PDPModal);
